module.exports = __webpack_public_path__ + "img/theme7Tran.132ddcda.png";